'use client'

import { Toaster as Sonner } from 'sonner'
import useStore from '@/hooks/useStore.js'
import { cn } from '@/utils/ui.js'
import { LoadingIndicator } from '@/components/ui/loadingIndicator.jsx'
import Icon from '@mdi/react'
import {
  mdiAlertOctagonOutline,
  mdiAlertOutline,
  mdiCheck,
  mdiClose,
  mdiInformationOutline,
} from '@mdi/js'
import { observer } from 'mobx-react-lite'

const TOAST_ICON_SIZE = 0.8

export const Toaster = observer(({ className, style, ...props }) => {
  const { responsiveStore, themeStore } = useStore()

  return (
    <Sonner
      className={cn('toaster group', className)}
      icons={{
        close: <Icon path={mdiClose} size={TOAST_ICON_SIZE} />,
        error: <Icon path={mdiAlertOctagonOutline} size={TOAST_ICON_SIZE} />,
        info: <Icon path={mdiInformationOutline} size={TOAST_ICON_SIZE} />,
        loading: <LoadingIndicator size={TOAST_ICON_SIZE} />,
        success: <Icon path={mdiCheck} size={TOAST_ICON_SIZE} />,
        warning: <Icon path={mdiAlertOutline} size={TOAST_ICON_SIZE} />,
      }}
      mobileOffset={{
        top: 'calc(var(--header-height, 0px) + var(--header-translate, 0px) + 12px)',
      }}
      offset={{ top: 'calc(var(--header-height, 0px) + 12px)' }}
      position={responsiveStore.isMd ? 'top-right' : 'top-center'}
      style={{
        '--normal-bg': 'var(--popover)',
        '--normal-border': 'var(--border)',
        '--normal-text': 'var(--popover-foreground)',
        ...style,
      }}
      theme={themeStore.theme}
      visibleToasts={responsiveStore.isMd ? 5 : 3}
      {...props}
    />
  )
})

// TODO: sometimes the icon does not show when an update is ready, maybe it's because of flex shrink?
export const getToastIconComponent = iconPath => <Icon path={iconPath} size={TOAST_ICON_SIZE} />
